module.exports = __webpack_public_path__ + "img/p4_new03.80ac8453.png";